export const TOGGLE_THEME = "TOGGLE_THEME";

export const toggleTheme = (mode) => ({
  type: TOGGLE_THEME,
  payload: mode,
});
